import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { apiAwards } from 'helpers/decorators/api'
import { connect } from 'react-redux'
import { modal } from '../../../../redux/modules/app'
import { get } from 'lodash'
import { Section, Title } from '../../../../components/layout'

@apiAwards()
@connect(state => ({
  isLoading: get(state, 'api.awards.loading')
}), { modal })
@form({
  form: 'form-change-award-type',
  disableHook: true
})
class AwardTypeChange extends Component {
  static propTypes = {
    awardId: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    onChangeAwardType: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool
  }


  render () {
    const {
      awardId,
      handleSubmit,
      isLoading
    } = this.props

    return (
      <Section loading={isLoading} inModal>
        <form
          onSubmit={handleSubmit(() =>
            this.props.onChangeAwardType(awardId)
          )}
        >

          <Title h3 intlKey="label.change_award_type">
            Do you want change award type?
          </Title>

          <div className="row">
            {!isLoading && (
              <div className="col-xs-6">
                <Button
                  type="button"
                  intlKey="button.cancel"
                  onClick={this.props.onClose}
                  secondary
                >
                  Cancel
                </Button>
              </div>
            )}

              <div className="col-xs-6 text--right">
                <Button
                  intlKey="button.change"
                  isLoading={isLoading}
                  disabled={isLoading}
                >
                  Change
                </Button>
              </div>
          </div>
        </form>
      </Section>
    )
  }
}

export default AwardTypeChange
